<a
    mat-flat-button
    color="warn"
    tabIndex="0"
    class="skip-link"
    (click)="focusMain()">
    {{ 'shared.skeleton.skipLinkText' | translate }}
</a>
<mat-sidenav-container>
    <mat-sidenav
        #sideNav
        role="navigation"
        [ariaLabel]="
            'shared.skeleton.navigation.mainNavigationLabel' | translate
        "
        [mode]="windowWidth < SIDENAV_BREAKPOINT ? 'over' : 'side'"
        [opened]="windowWidth < SIDENAV_BREAKPOINT ? 'false' : 'true'"
        class="{{ getDarkMode() ? DARK_MODE_CLASS : '' }}"
        fixedInViewport
        [style.width]="SIDENAV_WIDTH + 'px'">
        <div
            class="flex justify-end items-center"
            [style.height]="
                windowWidth < TOOLBAR_BREAKPOINT
                    ? 'var(--mat-toolbar-mobile-height)'
                    : 'var(--mat-toolbar-standard-height)'
            ">
            <div class="w-full">
                <img
                    class="w-[150px] mx-auto"
                    [src]="
                        '/assets/img/logos/' +
                        (getDarkMode() ? 'white' : 'dark') +
                        '.svg'
                    "
                    alt="{{ 'shared.logoAlt' | translate }}" />
            </div>
            <button
                mat-icon-button
                color="accent"
                attr.aria-label="{{
                    'shared.skeleton.navigation.collapseBtnLabel' | translate
                }}"
                class="me-2"
                (click)="sideNav.close()">
                <mat-icon> keyboard_backspace </mat-icon>
            </button>
        </div>

        <mat-divider />
        <ng-content select="[sideNavigation]" />
        <mat-divider />
    </mat-sidenav>
    <mat-sidenav-content
        role="region"
        class="{{ getDarkMode() ? DARK_MODE_CLASS : '' }}"
        [style.minHeight]="'100vh'">
        <apcam-main-layout>
            <!-- Toolbar -->
            <!-- TODO Replace caseName with something like 'context?.case?.caseName' -->
            <apcam-top-navbar
                ngProjectAs="header"
                [currentUser]="currentUser!"
                [showUserOrCaseName]="windowWidth > TOOLBAR_BREAKPOINT"
                [zone]="zone"
                [notificationCount]="notificationCount"
                [caseName]="undefined"
                (openNotificationDialog)="openNotificationDialog.emit()"
                [availableLanguages]="availableLanguages">
                <!-- Sidenav and toggleDarkMode buttons are here because they modify the variables in this component - <ng-content> used in child component for this purpose -->
                @if (!sideNav.opened) {
                    <button
                        sidenavButton
                        mat-icon-button
                        attr.aria-label="{{
                            'shared.skeleton.toolbar.openNavBtnLabel'
                                | translate
                        }}"
                        (click)="sideNav.toggle()">
                        <mat-icon aria-hidden="false"> menu </mat-icon>
                    </button>
                }
                @if (false) {
                    <!-- CSD-1198 Disabled dark mode until it is properly styled -->
                    <button
                        toggleDarkMode
                        mat-icon-button
                        [attr.aria-label]="
                            getDarkMode()
                                ? ('shared.skeleton.toolbar.darkModeSwitch.light'
                                  | translate)
                                : ('skeleton.toolbar.darkModeSwitch.dark'
                                  | translate)
                        "
                        (click)="toggleDarkMode()">
                        @if (getDarkMode()) {
                            <mat-icon>dark_mode</mat-icon>
                        } @else {
                            <mat-icon>light_mode</mat-icon>
                        }
                    </button>
                }
            </apcam-top-navbar>
            <main
                ngProjectAs="mainContent"
                class="p-2 sm:p-4 md:p-6 xl:p-8"
                [style.top]="windowWidth < TOOLBAR_BREAKPOINT ? '56px' : '64px'"
                [id]="idMain">
                <router-outlet />
                <!-- Support -->
                <ng-content select="[support]" />
                <p-scrollTop
                    buttonAriaLabel="{{ 'primeNG.aria.scrollTop' | translate }}"
                    behavior="smooth"
                    icon="pi pi-arrow-up"
                    [buttonProps]="{ severity: 'contrast', rounded: true }"
                    target="window"
                    [class]="
                        '[&_button]:z-10! [&_button]:w-14! [&_button]:h-14! ' +
                        (zone === PlatformZones.CLIENT_ZONE
                            ? '[&_button]:bottom-[90px]!'
                            : '')
                    "
                    [threshold]="
                        windowWidth < TOOLBAR_BREAKPOINT
                            ? TOOLBAR_MOBILE_HEIGHT
                            : TOOLBAR_STANDARD_HEIGHT
                    " />
            </main>
            <ng-content ngProjectAs="footer" select="[footer]" />
        </apcam-main-layout>
    </mat-sidenav-content>
</mat-sidenav-container>
